import { useCallback } from "react";

import { CalloutRefresh, ServicesForm } from "../components";
import { useConfig, useUser } from "../services";
import { LoadingScreen } from "./loading";
import { useNavigation } from "@react-navigation/native";

export function ServicesScreen() {
  // Data
  const {
    data: user,
    isLoading: isUserLoading,
    refetch: refetchUser,
  } = useUser();
  const {
    data: config,
    isLoading: isConfigLoading,
    refetch: refetchConfig,
  } = useConfig();

  // Vars
  const navigation = useNavigation();

  // Methods
  const refresh = useCallback(() => {
    refetchUser();
    refetchConfig();
  }, [refetchUser, refetchConfig]);

  // Handlers
  const handleSuccess = useCallback(() => {
    alert("Profile languages updated successfully!");

    navigation.goBack();
  }, [navigation]);

  // Render
  if (isUserLoading || isConfigLoading) {
    return <LoadingScreen />;
  }

  if (!user || !config) {
    return <CalloutRefresh onRefresh={refresh} />;
  }

  return (
    <ServicesForm
      services={config.services}
      user={user}
      onSuccess={handleSuccess}
    />
  );
}
